/**
 * Hook to get the active tab name from URL hash parameter
 * Based on the implementation from the old choco-admin-chats
 */

import { useLocation } from 'react-router-dom';

export const useActiveTabName = (): string => {
  const { hash } = useLocation();
  return hash.slice(1); // Remove the '#' prefix
};
